import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { AppSelector } from '../../../store/app'
import { StorageKeys } from '../../../store/Verification'
import { UserSelector } from '../../../store/User'

export const UserGreetingCard = () => {
  const user = useSelector(UserSelector.makeUserAbbreviated)
  const isSharedView = useSelector(AppSelector.getIsSharedView) || !!localStorage.getItem(StorageKeys.SHARE_TOKEN)
  return (
    <Box sx={{ p: 3 }}>
      {!isSharedView && <Typography variant="h5">Welcome back, {user.full_name}</Typography>}
      <Typography variant="body1">{isSharedView ? `${user.city}, ${user.state}` : user.short_location}</Typography>
    </Box>
  )
}